import React from "react";

import { favoritesEnabled, serverUrl } from "../../config";
import { Col } from "react-bootstrap";
import { Button } from "@mui/material";
import GridItem from "../../partials/gridItem";
import FavouriteBtn from "../../partials/favouriteBtn";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/CheckBoxOutlined";
import { parseSummary } from "../../partials/posts/postHelpers";

export default function TrainingItem(props) {
  const navigate = useNavigate();

  const itemId = props.item?.id ?? props.item?.nid;

  return (
    <GridItem
      xs={props.creator ? 6 : 12}
      sm={props.creator ? 3 : 6}
      md={props.creator ? 2 : 3}
      itemClass="training"
      item={props.item}
      bundle={props.item?.bundle}
      id={itemId}
      title={props.item?.title}
      field_body={props.creator ? "" : props.item?.summary ?? ""}
      category_label={props.item.category_labels}
      created={props.item?.created}
      hasImg={true}
      imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
      alt={`Poster for test ${itemId}`}
      cardActionArea={true}
      creator={props.creator}
      cardActionCallBack={
        props.creator ? () => {} : () => navigate(`/training/view/${itemId}`)
      }
      cardActions={true}
      chipWidth={8}
    >
      {props.item.submitted && (
        <Col xs={"auto"} className="d-flex align-items-center">
          <Button variant="screenItemBtn" mode="default" onClick={() => {}}>
            <CheckIcon sx={{ fontSize: "0.9rem" }} />
          </Button>
        </Col>
      )}
      {favoritesEnabled && (
        <FavouriteBtn
          id={itemId}
          mode={"default"}
          contentType={props.contentType}
        />
      )}
    </GridItem>
  );
}
